const state = {
  run: false,
  closed: false
}
const getters = {
  needToFilter: state => state.run,
  filtersClosed: state => state.closed
}
  
export default {
  state,
  getters
}